import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { OTAStatus } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseOTAStatus',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { t, tl } = useI18nTl('Evses')



const statusLabel = computed(() => {
  switch (props.state) {
    case OTAStatus.FW_Pending: // 准备中
      return tl('otaRequesting')
    case OTAStatus.FW_DownloadScheduled: // 固件下载计划中
    case OTAStatus.FW_Downloading: // 固件下载中
    case OTAStatus.FW_DownloadPaused: // 固件暂停下载
    case OTAStatus.FW_Downloaded: // 固件已下载
    case OTAStatus.FW_SignatureVerified: // 固件通过签名验证
    case OTAStatus.FW_InstallScheduled: // 固件安装计划中
    case OTAStatus.FW_Installing: // 固件安装中
    case OTAStatus.FW_Installed: // 固件安装成功
    case OTAStatus.FW_InstallRebooting: // 固件重启中
      return tl('otaProcessing')
    case OTAStatus.FW_DeliveryFail: // 下发失败
      return tl('otaRequestFail')
    case OTAStatus.FW_DeliverySuccess: // 下发成功
      return tl('otaRequestOK')
    case OTAStatus.FW_OTASuccess: // 升级成功
      return tl('otaOK')
    case OTAStatus.FW_InstallationFailed: // 失败的情况
    case OTAStatus.FW_InstallVerificationFailed: // 固件验证失败
    case OTAStatus.FW_InvalidSignature: // 固件验证签名失败
    case OTAStatus.FW_DownloadFailed: // 固件下载失败
      return tl('otaFail')
  }
  return t('Base.unknown')
})

const color = computed(() => {
  switch (props.state) {
    case (OTAStatus.FW_DeliveryFail, // 下发失败
    OTAStatus.FW_InstallationFailed, // 失败的情况
    OTAStatus.FW_InstallVerificationFailed, // 固件验证失败
    OTAStatus.FW_InvalidSignature, // 固件验证签名失败
    OTAStatus.FW_DownloadFailed): // 固件下载失败
      return '#5A5F6F'
  }

  return '#5e4eff'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "text-status",
    style: _normalizeStyle({ color: _unref(color) })
  }, _toDisplayString(_unref(statusLabel)), 5))
}
}

})